import React from "react";
import "../../Assessts/Styles/Gallery.scss";
import { FaYoutube } from "react-icons/fa";
const VideoGallery = () => {

    return (
        <div className=" mt-5     ">
            <div className="Web-MainHeading">Video Gallery</div>
           <div className="VideoGallery dflex flexd-column alignitems  CPointer JCCenter mt-5"
           onClick={()=>window.open("https://www.youtube.com/@northsouthindia/videos", "_blank")}> <FaYoutube/> https://www.youtube.com/@northsouthindia/videos</div>
        </div>
    )
}
export default VideoGallery;